import gql from 'graphql-tag';

export const REPORT_ITEM_FRAGMENT = gql`
  fragment ReportItemFields on BPFReportGroupDealDataViewModel {
    id
    stage

    location
    closeDate
    department
    dealStatus
    grossProfit
    closeStatus
    daysInStage
    probability
    overdueInDays
    invoiceAmount
    weightedAmount
    createdDateTime
    estimatedCloseDate

    contact
    customerName
    customerType
  }
`;
